import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc394cd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "relative flex items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "header-title" }, "Airspace Information", -1))
const _hoisted_4 = { class: "next-to-title-btn-ct" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "headerRightCt" }
const _hoisted_7 = { class: "feature-layer-ct" }
const _hoisted_8 = { class: "mt-1" }
const _hoisted_9 = { class: "font-medium mb-1" }
const _hoisted_10 = { class: "leading-snug" }
const _hoisted_11 = {
  key: 1,
  class: "text-xs mb-3 text-gray-600 bg-gray-100 rounded p-2 flex gap-x-2"
}
const _hoisted_12 = { class: "mt-1" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "No advisories found in this area. Follow the local rules and fly safely ", -1))
const _hoisted_14 = {
  key: 0,
  class: "layerCriticalityCt"
}
const _hoisted_15 = { class: "text-sm mb-2" }
const _hoisted_16 = { class: "layer-header-title" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "mb-3 text-xs text-gray-500" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "font-medium text-sm mt-5 my-3" }, "Weather, GPS and more", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"flex-basis":"100%"} }, "Disclaimer: For informational purposes only."),
  /*#__PURE__*/_createElementVNode("a", {
    target: "blank",
    href: "https://www.skylarkdrones.com/terms-of-service"
  }, "Terms of Service"),
  /*#__PURE__*/_createElementVNode("a", {
    target: "blank",
    href: "https://www.skylarkdrones.com/privacy-policy"
  }, "Privacy Policy")
], -1))
const _hoisted_21 = { class: "header" }
const _hoisted_22 = { class: "header-title ml-7" }
const _hoisted_23 = { class: "headerRightCt" }
const _hoisted_24 = { class: "feature-data-ct" }
const _hoisted_25 = {
  key: 0,
  class: "feature-prop"
}
const _hoisted_26 = { class: "prop-title" }
const _hoisted_27 = {
  key: 0,
  class: "prop-value"
}
const _hoisted_28 = ["href"]
const _hoisted_29 = { class: "header" }
const _hoisted_30 = { class: "header-title ml-7" }
const _hoisted_31 = { class: "headerRightCt" }
const _hoisted_32 = { class: "description-card" }
const _hoisted_33 = { class: "section" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "section-header" }, "Description", -1))
const _hoisted_35 = { class: "description" }
const _hoisted_36 = { class: "section" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "section-header" }, "Criticality", -1))
const _hoisted_38 = {
  key: 0,
  class: "section"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "section-header" }, "Recommendation", -1))
const _hoisted_40 = { class: "description" }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_ShareModal = _resolveComponent("ShareModal")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_AdvisoryList = _resolveComponent("AdvisoryList")!
  const _component_ui_collapse = _resolveComponent("ui-collapse")!
  const _component_ReportModal = _resolveComponent("ReportModal")!
  const _component_DmoCtaBanner = _resolveComponent("DmoCtaBanner")!
  const _component_SupplementaryData = _resolveComponent("SupplementaryData")!
  const _component_VSnackbar = _resolveComponent("VSnackbar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["feature-ct", {
      // 'layerDescription-ct': page === 'layer-description',
      // 'advisoryDetails-ct': page === 'advisory-details',
      'fullscreen-mobile':
        _ctx.fullscreen || _ctx.page === 'advisory-details' || _ctx.page === 'layer-description',
    }])
  }, [
    (_ctx.page === 'advisory-list')
      ? _renderSlot(_ctx.$slots, "default", { key: 0 }, () => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_ShareModal, { draw: _ctx.draw }, {
                  default: _withCtx(({ modalProp }) => [
                    _createElementVNode("button", _mergeProps(modalProp, { class: "share-btn" }), [
                      _createVNode(_component_Icon, { icon: "mdi:share" }),
                      _createTextVNode(" Share")
                    ], 16)
                  ]),
                  _: 1
                }, 8, ["draw"]),
                _createVNode(_component_v_tooltip, {
                  text: "Download as PDF",
                  location: "bottom"
                }, {
                  activator: _withCtx(({ props }) => [
                    _createElementVNode("button", _mergeProps(props, {
                      class: "report-download-btn",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.downloadReport && _ctx.downloadReport(...args))),
                      disabled: !_ctx.featureData || _ctx.reportDownloading || _ctx.featureLoading
                    }), [
                      (_ctx.reportDownloading)
                        ? (_openBlock(), _createBlock(_component_Icon, {
                            key: 0,
                            class: "loading-icon",
                            icon: "mdi:loading"
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_Icon, {
                        class: _normalizeClass(["icon", { loading: _ctx.reportDownloading }]),
                        icon: "mdi:download-outline"
                      }, null, 8, ["class"])
                    ], 16, _hoisted_5)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fullscreen = !_ctx.fullscreen)),
                class: "expand-btn"
              }, [
                _createVNode(_component_Icon, {
                  icon: _ctx.fullscreen ? 'mdi:chevron-down' : 'mdi:chevron-up'
                }, null, 8, ["icon"])
              ]),
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args))),
                class: "close-btn"
              }, [
                _createVNode(_component_Icon, { icon: "mdi:close" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_ctx.featureLoading)
              ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
              : _renderSlot(_ctx.$slots, "default", { key: 1 }, () => [
                  (_ctx.featureData?.zone)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["-m-4 text-sm mb-3 text-gray-800 bg-gray-100 rounded p-4 flex gap-x-3", {
              'bg-green-50 text-green-800': ['green', 'greenish'].includes(_ctx.featureData?.zone),
              'bg-red-50 text-red-800': _ctx.featureData?.zone === 'red',
              'bg-yellow-50 text-yellow-800': _ctx.featureData?.zone === 'yellow',
            }])
                      }, [
                        _createElementVNode("span", _hoisted_8, [
                          _createVNode(_component_Icon, {
                            icon: 
                  _ctx.ciriticalityIcon(
                    _ctx.featureData?.zone === 'green' || _ctx.featureData?.zone === 'greenish'
                      ? 'Free'
                      : _ctx.featureData?.zone === 'red'
                      ? 'Prohibited'
                      : 'Caution - Authorization Required'
                  )
                ,
                            class: _normalizeClass(["text-2xl", {
                  'text-green-600': ['green', 'greenish'].includes(_ctx.featureData?.zone),
                  'text-red-600': _ctx.featureData?.zone === 'red',
                  'text-yellow-600': _ctx.featureData?.zone === 'yellow',
                }])
                          }, null, 8, ["icon", "class"])
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("p", _hoisted_9, [
                            _createTextVNode(" You are in a "),
                            (['green', 'greenish'].includes(_ctx.featureData?.zone))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(" Green ")
                                ], 64))
                              : _createCommentVNode("", true),
                            (_ctx.featureData?.zone === 'red')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode("Red")
                                ], 64))
                              : _createCommentVNode("", true),
                            (_ctx.featureData?.zone === 'yellow')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createTextVNode("Yellow")
                                ], 64))
                              : _createCommentVNode("", true),
                            _createTextVNode(" Zone ")
                          ]),
                          _createElementVNode("p", _hoisted_10, [
                            (_ctx.featureData?.zone === 'green')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(" Fly safely within visual line of sight. ")
                                ], 64))
                              : _createCommentVNode("", true),
                            (_ctx.featureData?.zone === 'greenish')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(" However there are these additional advisories you should be aware of. Fly safely within visual line of sight ")
                                ], 64))
                              : _createCommentVNode("", true),
                            (_ctx.featureData?.zone === 'red')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createTextVNode(" Drone flights are prohibited ")
                                ], 64))
                              : _createCommentVNode("", true),
                            (_ctx.featureData?.zone === 'yellow')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                  _createTextVNode(" Ensure you have permission from local Air Traffic Controller and DGCA before flight ")
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ], 2))
                    : _createCommentVNode("", true),
                  (!_ctx.isFeatureData && !_ctx.featureData?.zone)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, [
                          _createVNode(_component_Icon, {
                            icon: "mdi:alert-circle-outline",
                            class: "text-base"
                          })
                        ]),
                        _hoisted_13
                      ]))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.featureData.advisory, (layers, criticality) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          layers
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("h4", _hoisted_15, _toDisplayString(_ctx.ciriticalityHeading(criticality)), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(layers, (layer) => {
                                  return (_openBlock(), _createBlock(_component_ui_collapse, {
                                    class: "layer-collapsable",
                                    key: layer
                                  }, {
                                    button: _withCtx((collapseProps) => [
                                      _createElementVNode("h3", {
                                        class: _normalizeClass(["layer-group-header", {
                      code_red: layer.metadata?.criticality === 'Prohibited',
                      code_green: layer.metadata?.criticality === 'Free',
                      code_gray: layer.metadata?.criticality === 'Caution - Information',
                      code_yellow:
                        layer.metadata?.criticality === 'Caution - Authorization Required',
                    }])
                                      }, [
                                        _createElementVNode("div", _hoisted_16, [
                                          _createVNode(_component_Icon, {
                                            icon: _ctx.ciriticalityIcon(criticality),
                                            class: "criticalityIcon"
                                          }, null, 8, ["icon"]),
                                          _createTextVNode(" " + _toDisplayString(layer.layer_title) + " (" + _toDisplayString(layer.data.length) + ") ", 1),
                                          _createVNode(_component_v_tooltip, {
                                            text: "About Layer",
                                            location: "top"
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createElementVNode("button", _mergeProps(props, {
                                                class: "help-btn",
                                                onClick: ($event: any) => (_ctx.toggleLayerDescriptionCard($event, layer.metadata.layerId))
                                              }), [
                                                _createVNode(_component_Icon, { icon: "mdi:help-circle-outline" })
                                              ], 16, _hoisted_17)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _createVNode(_component_v_tooltip, {
                                          text: collapseProps.isOpen ? 'Close' : 'Expand',
                                          location: "right"
                                        }, {
                                          activator: _withCtx(({ props }) => [
                                            _createVNode(_component_Icon, _mergeProps(props, {
                                              icon: "mdi:chevron-down",
                                              class: "icon"
                                            }), null, 16)
                                          ]),
                                          _: 2
                                        }, 1032, ["text"])
                                      ], 2)
                                    ]),
                                    default: _withCtx((slotProps) => [
                                      _createVNode(_component_AdvisoryList, {
                                        layerData: layer.data,
                                        layerKey: layer.layer_key,
                                        isVisible: slotProps.isOpen,
                                        onOnPlaceClick: _ctx.onPlaceClick,
                                        onOnReadMore: ($event: any) => (_ctx.toggleLayerDescriptionCard($event, layer.metadata.layerId))
                                      }, null, 8, ["layerData", "layerKey", "isVisible", "onOnPlaceClick", "onOnReadMore"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 256)),
                  _createElementVNode("p", _hoisted_18, [
                    _createTextVNode(" Something Wrong? "),
                    _createVNode(_component_ReportModal, { draw: _ctx.draw }, {
                      default: _withCtx(({ modalProp }) => [
                        _createElementVNode("button", _mergeProps(modalProp, {
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showReportModal = true)),
                          class: "hover:underline text-blue-400"
                        }), " Click here ", 16)
                      ]),
                      _: 1
                    }, 8, ["draw"]),
                    _createTextVNode(" to let us know ")
                  ]),
                  _createVNode(_component_DmoCtaBanner),
                  _hoisted_19,
                  _createVNode(_component_SupplementaryData),
                  _hoisted_20
                ], true)
          ])
        ], true)
      : _createCommentVNode("", true),
    (_ctx.page === 'advisory-details')
      ? _renderSlot(_ctx.$slots, "default", { key: 1 }, () => [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => {
            _ctx.page = 'advisory-list';
            _ctx.featureProperties = null;
          }),
              class: "p-2 hover:bg-gray-100 rounded-full absolute left-2 self-center"
            }, [
              _createVNode(_component_Icon, { icon: "mdi:arrow-left" })
            ]),
            _createElementVNode("h3", _hoisted_22, _toDisplayString(_ctx.featureProperties.name ?? 'N/A'), 1),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args))),
                class: "close-btn"
              }, [
                _createVNode(_component_Icon, { icon: "mdi:close" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processProperties(_ctx.featureProperties), ([key, value]) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_ctx.valueExist(value))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("span", _hoisted_26, _toDisplayString(key), 1),
                      (!_ctx.stringIsUrl(value))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(value), 1))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: value,
                            class: "prop-value"
                          }, [
                            _createTextVNode(_toDisplayString(value) + " ", 1),
                            _createVNode(_component_Icon, {
                              class: "icon",
                              icon: "mdi:external-link",
                              "font-size": "14",
                              inline: true
                            })
                          ], 8, _hoisted_28))
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 256))
          ])
        ], true)
      : _createCommentVNode("", true),
    (_ctx.page === 'layer-description')
      ? _renderSlot(_ctx.$slots, "default", { key: 2 }, () => [
          (_ctx.loadingLayerInformation)
            ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
            : _renderSlot(_ctx.$slots, "default", { key: 1 }, () => [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("button", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => {
              _ctx.page = 'advisory-list';
              _ctx.featureProperties = null;
            }),
                    class: "p-2 hover:bg-gray-100 rounded-full absolute left-2 self-center"
                  }, [
                    _createVNode(_component_Icon, { icon: "mdi:arrow-left" })
                  ]),
                  _createElementVNode("h3", _hoisted_30, _toDisplayString(_ctx.layerDetails?.title), 1),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("button", {
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args))),
                      class: "close-btn"
                    }, [
                      _createVNode(_component_Icon, { icon: "mdi:close" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.layerDetails?.description ?? 'Description Not Available'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createElementVNode("span", {
                      class: _normalizeClass(["cirticality-tag", {
                code_red: _ctx.layerDetails?.criticality === 'Prohibited',
                code_green: _ctx.layerDetails?.criticality === 'Free',
                code_gray: _ctx.layerDetails?.criticality === 'Caution - Information',
                code_yellow: _ctx.layerDetails?.criticality === 'Caution - Authorization Required',
              }])
                    }, _toDisplayString(_ctx.layerDetails?.criticality), 3)
                  ]),
                  (_ctx.layerDetails?.recommended_advisory)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _hoisted_39,
                        _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.layerDetails?.recommended_advisory), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.layerDetails?.read_more)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _createElementVNode("a", {
                          href: _ctx.layerDetails?.read_more,
                          target: "blank",
                          class: "readMoreBtn"
                        }, "Learn More", 8, _hoisted_42)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], true)
        ], true)
      : _createCommentVNode("", true),
    _createVNode(_component_VSnackbar, {
      location: "top center",
      class: _normalizeClass(_ctx.snackbar.status),
      modelValue: _ctx.snackbar.show,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.snackbar.show) = $event))
    }, {
      actions: _withCtx(() => [
        _createElementVNode("button", {
          class: "v-snackbar-close-btn",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.snackbar.show = false))
        }, [
          _createVNode(_component_Icon, { icon: "mdi:close" })
        ])
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.snackbar?.text) + " ", 1)
      ]),
      _: 1
    }, 8, ["class", "modelValue"])
  ], 2))
}